export function LoadingScreen() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="flex flex-col items-center">
        <img
          src="/maison-logo.jpg"
          alt="Maison Alemã"
          className="w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 object-contain"
          width={192}
          height={192}
        />
      </div>
    </div>
  );
}
